/** Switch Explore onto the source an assistant proposal reads - EOS unless
 * it says Live - with the same reset the Data source step does. */

import {
  activeDataSource,
  allColumns,
  selectedCols,
  selectedShip,
  shipDateRange,
} from '../../state/store.ts';
import { DEFAULT_SOURCE } from '../../state/data-sources.ts';
import { loadShips } from '../ship/ship-data.ts';

export async function ensureProposalSource(source: string = DEFAULT_SOURCE): Promise<void> {
  const changed = activeDataSource.value !== source;
  activeDataSource.set(source);
  if (typeof document !== 'undefined') document.body.dataset.datasource = source;
  if (!changed) return;

  selectedShip.set(null);
  allColumns.set([]);
  selectedCols.set(new Set());
  shipDateRange.set(null);
  await loadShips();
}

/** Exports read EOS only. */
export function ensureHistoricalProposalSource(): Promise<void> {
  return ensureProposalSource(DEFAULT_SOURCE);
}
